import genericRule from '../../FORMS/namespace/relation/doingCancel_namespace_relation';

export default {
    verb: 'doingCancel',
    namespace: 'sensor',
    relation: 'tag',
    description: genericRule.description,
    //this is the actual logic:
    logic: genericRule.logic
};
